/*
* @Author: zhangzhitao
* @Date: 2019-06-10 14:58:51
* @Des:
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-06-24 13:34:58
*/

<template>
  <div
    class="container home-page"
    :class="{ 'is-overdue': overdueFlag }"
  >
    <div
      v-for="(item, index) in arrList"
      :key="index"
      :style="
          `position:absolute;width:${item.width}%;height:${item.height}%;left:${
            item.xPos
          }%;top:${item.yPos}%;`
        "
    >
      <div
        class="m-widget-box"
        v-if="item.showTitleBar"
        :style="item.borderStyle + item.marginStyle"
      >
        <div
          class="u-parts-head"
          v-if="item.showTitleBar"
          :style="item.titleBarStyle"
        >
          {{ item.title }}
          <span
            @click="moreOpen(item)"
            class="u-more"
            v-if="item.showMore"
          >{{ $t("management.home.more_label") }}></span>
        </div>
        <widget-homepage
          ref="widgetRef"
          :comType="item.type"
          :comSubType="item.subType"
          :widgetId="item.id"
          :refreshPeriod="item.refreshPeriod"
          :url="item.fullUrl"
        ></widget-homepage>
      </div>
      <widget-homepage
        ref="widgetRef"
        v-if="!item.showTitleBar"
        :style="item.borderStyle + item.marginStyle"
        :comType="item.type"
        :comSubType="item.subType"
        :widgetId="item.id"
        :refreshPeriod="item.refreshPeriod"
        :url="item.fullUrl"
      ></widget-homepage>
    </div>
  </div>
</template>

<script>
import widgetHomepage from 'components/widget-homepage/widget-homepage.vue'
export default {
  name: 'full-screen',
  props: {
    overdueFlag: {
      type: Boolean,
      default: false
    },
    arrList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },

  components: { widgetHomepage },

  computed: {},

  mounted () { },

  methods: {}
}

</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  .m-widget-box {
    width: 100%;
    height: calc(~"100% - 40px");
  }
  .u-parts-head {
    width: 100%;
    height: 40px;
    font-size: 14px;
    color: #4c4c4c;
    letter-spacing: 0;
    line-height: 40px;
    text-indent: 10px;
    box-sizing: border-box;
    .u-more {
      float: right;
      margin-right: 10px;
      font-size: 12px;
      color: #7f7f7f;
      text-decoration: none;
      cursor: pointer;
    }
  }
  /deep/ .m-scroll-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
.is-overdue {
  height: calc(~"100% - 34px");
}
</style>
